export default __webpack_public_path__ + "static/sct_logo-2dd1d188fbd294b959fa49f40d28b662.svg";